import React from 'react';
import { Image } from 'components';
import {} from 'constants/ui';
import { getAcceptPartnershipGraphicUrl } from 'helpers/ui';
const AcceptPartnershipIllustrationBase = ({ acceptPartnershipState, className }) => (React.createElement(Image, { alt: `${acceptPartnershipState} illustration`, className: className, src: getAcceptPartnershipGraphicUrl(acceptPartnershipState) }));
export default AcceptPartnershipIllustrationBase;
